import { head } from 'lodash';

export default [ 'startTimeApiService', 'availabilityService', 'loadingService', (startTimeApiService, availabilityService, loadingService) => {
  const getStartTimes = (item) => {
    return startTimeApiService.find(item.date, item.type || item.type_name, item.id)
      .then(response => {
        availabilityService.setSingleTimes(response);

        loadingService.stopLoading('times');
        return response;
      });
  };

  const getStartTimesSetPreferred = (item) => {
    return getStartTimes(item)
      .then(() => {
        return setPreferred(item);
      });
  };

  const standardiseTime = (time) => {
    if (time.split(':').length === 2) {
      return `${time}:00`;
    }

    return time;
  };

  const displayTime = (time) => {
    return time.substring(0, 5);
  };

  const setPreferred = (item) => {
    if (!availabilityService.hasSingleTimes()) {
      item.preferred_time = undefined;
      return item;
    }

    const times = availabilityService.getSingleTimes();
    if (times.length === 1) {
      const startTime = head(times);
      item.preferred_time = `${startTime.time}`;
      item.end_time = `${startTime.end}`;
      item.original = startTime.original_price || item.original;
      item.price = startTime.price || item.price;

      return item;
    }

    if (item.preferred_time &&
        (!times.some((startTime) => {
          if (standardiseTime(item.preferred_time) === startTime.time) {
            item.original = startTime.original_price || item.original;
            item.price = startTime.price || item.price;
            return true;
          }
        }))) {
      item.preferred_time = undefined;
    }

    return item;
  };

  return {
    getStartTimes,
    getStartTimesSetPreferred,
    standardiseTime,
    displayTime
  };
} ];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/availability/services/startTime.service.js